import EditRateSectionDialog from './EditRateSectionDialog'

export default EditRateSectionDialog
